import { useMemo } from 'react';
import { Box } from '@mui/material';
import Chart from '../common/Chart';
import ChartProvider from '../../contexts/ChartContext';
import { asNamedSolutions, type ScreenSolution, type TimeSeries } from '../../types';
import { soilingRatioChartData } from '../../utils/chartOptions/solutionSeries';
import {
  ALIGNED_CHART_MARGIN_LEFT,
  ALIGNED_CHART_MARGIN_RIGHT,
  ALIGNED_CHART_TICK_INTERVAL,
} from '../../utils/chartOptions/cleaningSchedules';

type Props = {
  rain_dates: string[] | undefined;
  reference: TimeSeries;
  solutions: ScreenSolution[];
  ymin?: number;
  ymax?: number;
};

const SoilingRatioChart = ({ rain_dates, reference, solutions, ymin, ymax }: Props) => {
  const data = useMemo(
    () =>
      Object.prototype.hasOwnProperty.call(reference, 'times') && solutions.length > 0
        ? soilingRatioChartData(rain_dates, reference, asNamedSolutions(solutions))
        : null,
    [reference, solutions],
  );

  return (
    <>
      <Box sx={{ justifyContent: 'center', pl: 1, pr: 1 }}>
        {data ? (
          <>
            <ChartProvider>
              <Box>
                <Chart
                  data={data}
                  ymin={ymin}
                  ymax={ymax}
                  datetimeAxis
                  marginLeft={ALIGNED_CHART_MARGIN_LEFT}
                  marginRight={ALIGNED_CHART_MARGIN_RIGHT}
                  tickInterval={ALIGNED_CHART_TICK_INTERVAL}
                />
              </Box>
            </ChartProvider>
          </>
        ) : null}
      </Box>
    </>
  );
};

export default SoilingRatioChart;
